import Control from "ol/control/Control";
import Vue from "vue";

export default class CarLiveTrackingControl extends Control {
  liveTracking = false;
  private isVisible = true;
  private readonly button = document.createElement('button');
  private readonly icon = document.createElement('i');

  constructor() {
    super({ element: document.createElement('div') });
    this.setBtnProperties();
    this.icon.className = 'v-icon material-icons theme--light';
    this.button.appendChild(this.icon);
    this.button.addEventListener('click', this.handleTrackCar.bind(this));
    this.element.className = 'ol-control car-live-tacking-btn';
    this.element.appendChild(this.button);
  }

  handleTrackCar() {
    this.liveTracking = !this.liveTracking;
    this.setBtnProperties();
    this.dispatchEvent('change');
  }

  setBtnProperties() {
    this.icon.innerHTML = this.liveTracking ? 'pause' : 'play_arrow';
    this.button.title = this.liveTracking
      ? Vue.i18n.translate('routeDetails.stopShowingCarLiveLocation')
      : Vue.i18n.translate('routeDetails.showCarLiveLocation');
  }

  changeBtnVisibility() {
    this.isVisible = !this.isVisible;
    this.element.style.display = this.isVisible ? 'block' : 'none';
    // If the button is hidden, stop live tracking and vice versa
    if ((!this.isVisible && this.liveTracking) || (this.isVisible && !this.liveTracking)) {
      this.handleTrackCar();
    }
  }
}